import React, { useEffect, useState } from "react";
import SideBar from "../components/SideBar";
import { captainTcCardService } from "../services/captainTcCardService";
import { retailerService } from "../services/RetailerServices";
import CaptainTcCardAssignForm from "../components/CaptainTcCardAssignForm";
import CaptainTcCardEditForm from "../components/CaptainTcCardEditForm";
import CaptainTcCardGenerateForm from "../components/CaptainTcCardGenerateForm";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function ManageCaptainTcCards() {
  const [assignments, setAssignments] = useState([]);
  const [retailers, setRetailers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const navigate = useNavigate();
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState(null);

  const [expandedRow, setExpandedRow] = useState(null);
  const [batchRecords, setBatchRecords] = useState({});
  const [loadingRecords, setLoadingRecords] = useState(false);

  // Filters and pagination
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [cardsRes, retailRes] = await Promise.all([
        captainTcCardService.getAllAssignments(),
        retailerService.getAllRetailers({ per_page: 1000 })
      ]);
      if (cardsRes.status) {
        setAssignments(cardsRes.data);
      }
      if (retailRes.users) {
        setRetailers(retailRes.users);
      }
    } catch (error) {
      console.error("Failed to load data:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatCardNo = (num) => {
    return num || "";
  };

  const filteredAssignments = assignments.filter((assign) => {
    const startSerialStr = assign.start_serial?.toString() || "";
    const endSerialStr = assign.end_serial?.toString() || "";
    const retailName = assign.retail_business?.first_name || "";
    return (
      startSerialStr.includes(search) ||
      endSerialStr.includes(search) ||
      retailName.toLowerCase().includes(search.toLowerCase())
    );
  });

  const totalPages = Math.ceil(filteredAssignments.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedAssignments = filteredAssignments.slice(startIndex, startIndex + itemsPerPage);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this assignment?")) {
      try {
        await captainTcCardService.deleteAssignment(id);
        toast.success("Assignment deleted successfully");
        fetchData();
      } catch (error) {
        toast.error("Failed to delete assignment");
      }
    }
  };

  const handleEdit = (assignment) => {
    setSelectedAssignment(assignment);
    setShowEditModal(true);
  };

  const handleRowClick = async (id) => {
    if (expandedRow === id) {
      setExpandedRow(null);
      return;
    }
    setExpandedRow(id);
    if (!batchRecords[id]) {
      setLoadingRecords(true);
      try {
        const res = await captainTcCardService.getBatchRecords(id);
        if (res.status) {
          setBatchRecords(prev => ({ ...prev, [id]: res.data }));
        }
      } catch (error) {
        toast.error("Failed to load batch records");
      } finally {
        setLoadingRecords(false);
      }
    }
  };

  return (
    <div className="manage-member-layout">
      <SideBar />
      <div className="main-content">
        <div className="header-bar" style={{ border: 0, boxShadow: "none" }}>
          <div className="header-top">
            <h2 className="header-title">Manage Captain TC Gold Cards</h2>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button className="action-btn" onClick={() => setShowGenerateModal(true)} style={{ backgroundColor: '#10b981' }}>
                + Create Cards
              </button>
              <button className="action-btn" onClick={() => navigate("/view-available-captain-tc-cards")} style={{ backgroundColor: '#3b82f6' }}>
                View Cards
              </button>
              <button className="action-btn" onClick={() => setShowAssignModal(true)}>
                + Assign Cards
              </button>
            </div>
          </div>

          <div className="filters">
            <div className="input-group">
              <label>Search:</label>
              <input
                type="text"
                placeholder="Search by Retailer"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
                className="search-input"
               maxLength={20} />
            </div>
          </div>

          {loading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>Loading...</div>
          ) : (
            <div className="table-container">
              <table className="member-table">
                <thead>
                  <tr>
                    {/* <th>Batch ID</th> */}
                    <th>Retail Business ID</th>
                    <th>Retail Business</th>
                    <th>Start Card No</th>
                    <th>End Card No</th>
                    <th>Start Serial</th>
                    <th>End Serial</th>
                    <th>Quantity</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedAssignments.length > 0 ? (
                    paginatedAssignments.map((assign) => (
                      <React.Fragment key={assign.id}>
                        <tr onClick={() => handleRowClick(assign.id)} style={{ cursor: "pointer", transition: "background-color 0.2s" }} onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"} onMouseOut={(e) => e.currentTarget.style.backgroundColor = "transparent"}>
                          {/* <td>{assign.id}</td> */}
                          <td>{assign.retail_business_id}</td>
                          <td>
                            {assign.retail_business?.first_name} {assign.retail_business?.last_name}
                          </td>
                          <td>{assign.start_card_no}</td>
                          <td>{assign.end_card_no}</td>
                          <td>{assign.start_serial}</td>
                          <td>{assign.end_serial}</td>
                          <td>{assign.quantity}</td>
                          <td>
                            <span className={`status ${assign.status}`}>
                              {assign.status}
                            </span>
                          </td>
                          <td onClick={(e) => e.stopPropagation()}>
                            <button
                              className="btn-edit"
                              onClick={() => handleEdit(assign)}
                              style={{ marginRight: "10px", padding: "5px 10px", cursor: "pointer" }}
                            >
                              Edit
                            </button>
                          </td>
                        </tr>
                        {expandedRow === assign.id && (
                          <tr>
                            <td colSpan="10" style={{ backgroundColor: "#f9f9f9", padding: "15px", borderBottom: "1px solid #eee" }}>
                              {loadingRecords && !batchRecords[assign.id] ? (
                                <div style={{ textAlign: "center", padding: "10px" }}>Loading records...</div>
                              ) : (
                                <div style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#fff" }}>
                                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
                                    <thead style={{ backgroundColor: "#eaeaea", position: "sticky", top: 0, zIndex: 1 }}>
                                      <tr>
                                        <th style={{ padding: "10px", textAlign: "left", borderBottom: "2px solid #ccc" }}>Card No</th>
                                        <th style={{ padding: "10px", textAlign: "left", borderBottom: "2px solid #ccc" }}>Serial Number</th>
                                        <th style={{ padding: "10px", textAlign: "left", borderBottom: "2px solid #ccc" }}>Status</th>
                                        <th style={{ padding: "10px", textAlign: "left", borderBottom: "2px solid #ccc" }}>Created At</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {batchRecords[assign.id]?.length > 0 ? (
                                        batchRecords[assign.id].map((record) => (
                                          <tr key={record.id} style={{ borderBottom: "1px solid #eee" }}>
                                            <td style={{ padding: "8px 10px" }}>{record.card_number}</td>
                                            <td style={{ padding: "8px 10px" }}>{record.serial_number}</td>
                                            <td style={{ padding: "8px 10px" }}>
                                              <span className={`status ${record.status}`} style={{ fontSize: "12px", padding: "2px 6px" }}>
                                                {record.status}
                                              </span>
                                            </td>
                                            <td style={{ padding: "8px 10px" }}>
                                              {new Date(record.created_at).toLocaleString()}
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="4" style={{ padding: "10px", textAlign: "center" }}>No records found in this batch.</td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" style={{ textAlign: "center" }}>
                        No assignments found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="pagination">
                <button
                  className="page-btn"
                  onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                  disabled={currentPage === 1}
                >
                  &lt;
                </button>
                {Array.from({ length: totalPages }, (_, i) => (
                  <button
                    key={i}
                    className={`page-btn ${currentPage === i + 1 ? "active" : ""}`}
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}
                <button
                  className="page-btn"
                  onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  &gt;
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {showAssignModal && (
        <CaptainTcCardAssignForm
          retailers={retailers}
          onClose={() => setShowAssignModal(false)}
          onSuccess={() => {
            setShowAssignModal(false);
            fetchData();
          }}
        />
      )}

      {showGenerateModal && (
        <CaptainTcCardGenerateForm
          onClose={() => setShowGenerateModal(false)}
          onSuccess={() => {
            setShowGenerateModal(false);
            fetchData();
          }}
        />
      )}

      {showEditModal && selectedAssignment && (
        <CaptainTcCardEditForm
          assignment={selectedAssignment}
          onClose={() => {
            setShowEditModal(false);
            setSelectedAssignment(null);
          }}
          onSuccess={() => {
            setShowEditModal(false);
            setSelectedAssignment(null);
            fetchData();
          }}
        />
      )}
    </div>
  );
}

export default ManageCaptainTcCards;
